import { Injectable } from '@angular/core';

import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IFormaPagamento } from '../models/forma-pagamento.model';

@Injectable()
export class FormaPagamentoService extends EntityService<IFormaPagamento> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'forma_pagamento'
      }
    );
  }
}
